import { render } from "@/components/pages/dataRecollection/allCustomize/AllCustomizePage.html?vue&type=template&id=536f1b2a&external"
import script from "@/components/pages/dataRecollection/allCustomize/AllCustomizePage.js?vue&type=script&lang=js&external"
export * from "@/components/pages/dataRecollection/allCustomize/AllCustomizePage.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__